// Who runs Jookable and how to reach them. YouTube's API policies require an app that uses
// the YouTube API Services to give its users contact information, so this appears in the
// Terms, the Privacy Policy and the page footers.
export const COMPANY_NAME = 'VE BOLA';
export const CONTACT_EMAIL = 'logan@logandirks.com';
